import React, { useState } from 'react';
import { Box, Grid, Paper, Typography, Button, IconButton, useTheme, Divider } from '@mui/material';
import { Add, Refresh } from '@mui/icons-material';
import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { useSSR } from 'react-i18next';
import { tokens } from '../../theme/theme';
import LeadTargetGauge from '../../components/target-gauge';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AA66CC', '#FF4444', '#33B5E5', '#99CC00'];

const leadsBySource = [
    { name: 'Web Download', value: 1 },
    { name: 'Advertisement', value: 2 },
    { name: 'Cold Call', value: 2 },
    { name: 'External Referral', value: 1 },
    { name: 'Online Store', value: 2 },
    { name: 'Partner', value: 1 },
    { name: 'Seminar Partner', value: 1 },
];

const revenueData = [
    { name: 'Entire Org', achieved: 700000, target: 1000000 },
];

const OrgOverview = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Box p={0}>
            <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor={colors.primary[400]} padding={1} mb={2}>
                <Box>
                    <Typography variant="h6">Org Overview</Typography>
                    <Typography variant="caption" color="textSecondary">Add Description</Typography>
                </Box>
                <Box>
                    <IconButton><Refresh /></IconButton>
                    <Button variant="contained" startIcon={<Add />}>Add Component</Button>
                </Box>
            </Box>


            <Grid container spacing={2} padding={2}>
                {/* Top Stats */}
                <Grid item xs={3}><StatCard title="LEADS THIS MONTH" value="10" change="100%" /></Grid>
                <Grid item xs={3}><StatCard title="REVENUE THIS MONTH" value="$35,000.00" change="100%" /></Grid>
                <Grid item xs={3}><StatCard title="DEALS IN PIPELINE" value="8" /></Grid>
                <Grid item xs={3}><StatCard title="ACCOUNTS THIS MONTH" value="10" change="100%" /></Grid>

                {/* Lead Target Gauge Placeholder */}
                <Grid item xs={6}   >
                   <LeadTargetGauge value={600}target={1000}/>
                </Grid>

                {/* Revenue Target Bar */}
                <Grid item xs={6}>
                    <Paper sx={{ p: 2 ,backgroundColor:colors.primary[500] }}>
                        <Typography variant="subtitle1" gutterBottom>REVENUE TARGET - THIS YEAR</Typography>
                        <ResponsiveContainer width="100%" height={180}>
                            <BarChart data={revenueData} layout="vertical">
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis type="number" hide />
                                <YAxis type="category" dataKey="name" />
                                <Tooltip />
                                <Bar dataKey="achieved" fill="#82ca9d" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Paper>
                </Grid>

                {/* Last 3 Month Monitor */}
                <Grid item xs={6}>
                    <Paper sx={{ p: 2 ,backgroundColor:colors.primary[500] }}>
                        <Typography variant="subtitle1" gutterBottom>LAST 3 MONTHS PERFORMANCE MONITOR</Typography>
                        <Typography variant="body2">May 2025</Typography>
                        <Box mt={1}>
                            <MonitorRow label="LEADS CREATED" value="10" />
                            <MonitorRow label="DEALS CREATED" value="10" bg />
                            <MonitorRow label="DEALS WON" value="1" />
                            <MonitorRow label="REVENUE WON" value="$35,000.00" bg />
                            <MonitorRow label="OPEN AMOUNT" value="$620,000.00" />
                        </Box>
                    </Paper>
                </Grid>

                {/* Leads by Source Pie */}
                <Grid item xs={3}>
                    <Paper sx={{ p: 2,backgroundColor:colors.primary[500]  }}>
                        <Typography variant="subtitle1" gutterBottom>LEADS BY SOURCE</Typography>
                        <ResponsiveContainer width="100%" height={250}>
                            <PieChart>
                                <Pie data={leadsBySource} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80}>
                                    {leadsBySource.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                            </PieChart>
                        </ResponsiveContainer>
                    </Paper>
                </Grid>

                {/* Prolific Sales Reps */}
                <Grid item xs={3}>
                    <Paper sx={{ p: 2,backgroundColor:colors.primary[500] }}>
                        <Typography variant="subtitle1" gutterBottom>PROLIFIC SALES REPS</Typography>
                        <Typography variant="body2">1. thiravida selvam</Typography>
                        <Typography variant="body2" fontWeight="bold">$35,000.00</Typography>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

const StatCard = ({ title, value, change }) => (
    <Paper sx={{ p: 2 }}>
        <Typography variant="caption" color="textSecondary">{title}</Typography>
        <Typography variant="h6">{value}</Typography>
        {change && <Typography variant="caption" color="green">{change}</Typography>}
        <Typography variant="caption" color="textSecondary">Last Month Relative: 0</Typography>
    </Paper>
);

const PlaceholderCard = ({ title, subtitle }) => (
    <Paper sx={{ p: 2, minHeight: 180 }}>
        <Typography variant="subtitle1">{title}</Typography>
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography variant="body2">{subtitle}</Typography>
        </Box>
    </Paper>
);

const MonitorRow = ({ label, value, bg }) => (
    <Box display="flex" justifyContent="space-between" bgcolor={bg ? '#f5f5f5' : 'transparent'} px={1} py={0.5}>
        <Typography variant="body2">{label}</Typography>
        <Typography variant="body2">{value}</Typography>
    </Box>
);

export default OrgOverview;
